
import { useState } from 'react';

export const useCustomerFormState = (initialData: any = null) => {
  // Utiliser une vérification pour s'assurer que initialData n'est pas null avant d'accéder à ses propriétés
  const [name, setName] = useState(initialData?.name || '');
  const [email, setEmail] = useState(initialData?.email || '');
  const [phone, setPhone] = useState(initialData?.phone || '');
  const [selectedCountryCode, setSelectedCountryCode] = useState('DZ');
  const [country, setCountry] = useState(initialData?.country || '');
  const [region, setRegion] = useState(initialData?.region || '');
  const [municipality, setMunicipality] = useState(initialData?.municipality || '');
  const [address, setAddress] = useState(initialData?.address || '');
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    
    if (!name.trim()) {
      newErrors.name = "Name is required";
    }
    
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is not valid";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    selectedCountryCode,
    setSelectedCountryCode,
    country,
    setCountry,
    region,
    setRegion,
    municipality,
    setMunicipality,
    address,
    setAddress,
    errors,
    setErrors,
    validateForm
  };
};

// For backwards compatibility
export const useClientFormState = useCustomerFormState;
